module.exports = __webpack_public_path__ + "img/avatar6.918408a5.png";